import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
//import Detail from "./pages/detail/Detail";
import Search from "./pages/search/Search";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBed,
  faPlane,
  faCar,
  faTaxi,
} from "@fortawesome/free-solid-svg-icons";
import { lazy, Suspense } from "react";

library.add(faBed, faPlane, faCar, faTaxi);

const Detail = lazy(() => import("./pages/detail/Detail"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route
          path="/detail"
          element={
            <Suspense fallback={<p>Loading...</p>}>
              <Detail />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
//khi thực hiện lazyload ta cần làm cả hàm loader nếu có trong thành phần
//vd: loader: () => import(./pages/detail/Detail).then(module => module.loader())
